import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
const SelectionEventContext = createContext(undefined);
export const SelectionEventContextProvider = ({ children, onSelectionChange }) => {
    const contextValue = React.useMemo(() => ({ onSelectionChange }), [onSelectionChange]);
    return (_jsx(SelectionEventContext.Provider, { value: contextValue, children: children }));
};
export const useSelectionEventHandler = () => {
    const context = useContext(SelectionEventContext);
    if (context === undefined) {
        throw new Error('useSelectionEventHandler must be used within a SelectionEventContextProvider');
    }
    return context;
};
//# sourceMappingURL=SelectionEventContext.js.map